import { Container, getTextByName, Text } from '../utils/utils';

export default class TextLabels {
  // ================================================================================================
  // properties
  // ================================================================================================
  private txtMainColor: Text;

  private txtSecondColor: Text;

  private txtThirdColor: Text;

  private txtWorkingColor: Text;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(container: Container) {
    this.txtWorkingColor = getTextByName(container, 'txt_working_color');
    this.txtMainColor = getTextByName(container, 'txt_main_color');
    this.txtSecondColor = getTextByName(container, 'txt_second_color');
    this.txtThirdColor = getTextByName(container, 'txt_third_color');
  }

  // ----------------------------------------------------------------------------------------------
  set main(value: string) {
    TextLabels.SetText(this.txtMainColor, value);
  }

  // ----------------------------------------------------------------------------------------------
  set second(value: string) {
    TextLabels.SetText(this.txtSecondColor, value);
  }

  // ----------------------------------------------------------------------------------------------
  set third(value: string) {
    TextLabels.SetText(this.txtThirdColor, value);
  }

  // ----------------------------------------------------------------------------------------------
  set working(value: string) {
    TextLabels.SetText(this.txtWorkingColor, value);
  }

  // ================================================================================================
  // private
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  private static SetText(textObject: Text, value: string): void {
    if (textObject) {
      textObject.text = value || '';
    }
  }
}
